import styled from 'styled-components';

export const Media = styled.div`
  width: 100%;
  height: 300px;
  border-radius: 18px;
`;
